import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Star } from 'lucide-react';
import { showPath } from '../../utils/regions';

const RelatedShows = ({ related, region }) => {
  const navigate = useNavigate();
  if (!related || related.length === 0) return null;

  const toShow = (id) => {
    navigate(showPath(id, region));
    // ensure we land at the top of the new page
    if (typeof window !== 'undefined') window.scrollTo({ top: 0, behavior: 'instant' });
  };

  return (
    <section className="block" data-testid="show-related">
      <h2 className="block-title">If you like this, try…</h2>
      <div className="related-grid">
        {related.map((s) => (
          <button
            type="button"
            key={s.tmdb_id}
            className="related-card"
            data-testid={`related-${s.tmdb_id}`}
            onClick={() => toShow(s.tmdb_id)}
          >
            <div className="related-poster">
              {s.image_url ? (
                <img src={s.image_url} alt={`${s.title} poster`} loading="lazy" />
              ) : (
                <div className="related-fallback">🐑</div>
              )}
            </div>
            <div className="related-meta">
              <div className="related-title">{s.title}</div>
              <div className="related-line">
                {s.year || ''}
                {s.vote_average ? (
                  <>
                    {s.year ? ' • ' : ''}
                    <span className="score"><Star size={11} /> {s.vote_average.toFixed(1)}</span>
                  </>
                ) : null}
              </div>
            </div>
          </button>
        ))}
      </div>

      <style jsx>{`
        .block {
          margin: 2.5rem 0;
        }
        .block-title {
          color: #E62F88;
          font-size: 0.72rem;
          font-weight: 800;
          letter-spacing: 0.2em;
          text-transform: uppercase;
          margin: 0 0 1.1rem;
        }
        .related-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
          gap: 0.85rem;
        }
        .related-card {
          background: #131313;
          border: 1px solid #232323;
          border-radius: 10px;
          padding: 0.6rem;
          cursor: pointer;
          color: #fff;
          text-align: left;
          transition: border-color 0.18s, transform 0.18s;
        }
        .related-card:hover {
          border-color: rgba(230, 47, 136, 0.4);
          transform: translateY(-2px);
        }
        .related-poster {
          aspect-ratio: 2 / 3;
          width: 100%;
          background: #0a0a0a;
          border-radius: 8px;
          overflow: hidden;
          margin-bottom: 0.5rem;
        }
        .related-poster img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
        }
        .related-fallback {
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1.5rem;
        }
        .related-title {
          color: #fff;
          font-size: 0.85rem;
          font-weight: 700;
          line-height: 1.2;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .related-line {
          color: #a1a1aa;
          font-size: 0.72rem;
          margin-top: 0.2rem;
          display: inline-flex;
          align-items: center;
          gap: 0.2rem;
        }
        .score {
          display: inline-flex;
          align-items: center;
          gap: 0.15rem;
          color: #facc15;
          font-weight: 700;
        }
      `}</style>
    </section>
  );
};

export default RelatedShows;
